import { render, staticRenderFns } from "./SamSung.vue?vue&type=template&id=442fe4ac&"
import script from "./SamSung.vue?vue&type=script&lang=js&"
export * from "./SamSung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports